/* eslint-disable react/prop-types */
import {
  Button,
  Card,
  CardActions,
  CardContent,
  FormControlLabel,
  FormGroup,
  Grid,
  LinearProgress,
  Snackbar,
  SnackbarContent,
  Switch,
} from "@material-ui/core";
import "./EditoraFabricante.scss";
import * as React from "react";
import { useEffect, useState } from "react";
import Rest from "src/services/Rest";
import { getError } from "src/services/ErrorService";
import SelectSingle from "src/component/selectsingle/SelectSingle";

const styles = {
  textField: {
    marginLeft: 5,
    marginRight: 5,
  },
};
export interface IEditoraFabricanteProps {
    closeForm(): void;
  }

interface IEditora {
  value: null;
   label: '';
}

interface IFabricante {
  value: null;
   label: '';
}

function EditoraFabricanteForm(props: IEditoraFabricanteProps) {
  const { closeForm } = props;
  const [editoraFilterChecked, setStateEditoraFilterChecked] = useState<boolean>(true);
  const [fabricanteFilterChecked, setStateFabricanteFilterChecked] = useState<boolean>(true);
  const [listEditoras, setListEditoras] = useState([]);
  const [listFabricantes, setListFabricantes] = useState([])
  const [editora, setEditora] = useState<IEditora | null>(null);
  const [fabricante, setFabricante] = useState<IFabricante | null>(null);
  const [loading, setSateLoading] = useState<boolean>(false);
  const [alert, setStateAlert] = useState({
    message: "",
    open: false,
    type: "",
  });

  const openAlert = (msg: string, tipo: string) => {
    const item = { message: msg, type: tipo, open: true };
    setStateAlert(item);
  };

  const closeAlert = () => {
    const item = { message: "", type: "", open: false };
    setStateAlert(item);
  }; 

  const handleFabricante =(ev: any) => {
    setFabricante(ev) 
  }
  
  const handleEditora =(ev: any) => {
    setEditora(ev) 
  }

  const handleEditorasChecked = () => {
      const valor = !editoraFilterChecked
      setStateEditoraFilterChecked(valor)
      setEditora(null)
      searchEditora(valor)
  }

  const handleFabricanteChecked = () => {
    const valor = !fabricanteFilterChecked
    setStateFabricanteFilterChecked(valor)
    setFabricante(null)
    searchFabricantes(valor)
}

  const saveEditora = async () => {
    try {
      if (!editora || !editora.value) {
        return openAlert("Obrigatório selecionar Editora Simpleset", "erro")
      }
      if (!fabricante || !fabricante.value) {
        return openAlert("Obrigatório selecionar Editora Bookinfo", "erro");
      }
      const params = {
        editoraDp: editora.label,
        fabricante: fabricante.label,
        idDp: editora.value,
        idFabricante: fabricante.value
      }
      setSateLoading(true);
      const response = await Rest.PostBody("editora-fabricante", params);
      if (response) {
        openAlert("Novo relacionamento salvo com sucesso.", "success");
        setSateLoading(false)
        closeForm();
      }
    } catch (error) {
    const erro = getError(error);
      openAlert(erro.message, "erro");
      setSateLoading(false);
  }  
}

  const searchEditora = async (indAssociado: boolean) => {
    setSateLoading(true);
    const endPoint = `editora-fabricante/editoras?indAssociado=${indAssociado}`;
    
    await Rest.GET(endPoint, null)
      .then((response) => response.json())
      .then((result: any) => {
        if (result && result.error) {
          const erro = getError(result.error);
          openAlert(erro.message, "erro");
        } else {
          setListEditoras(result);
          setSateLoading(false);
      }});
  };
  useEffect(() => {
    searchEditora(editoraFilterChecked);
  }, []);

  const searchFabricantes = async (indAssociado: boolean) => {
    setSateLoading(true);
    const endPoint = `editora-fabricante/fabricantes?indAssociado=${indAssociado}`;
    
    await Rest.GET(endPoint, null)
      .then((response) => response.json())
      .then((result: any) => {
        if (result && result.error) {
          const erro = getError(result.error);
          openAlert(erro.message, "erro");
        } else {
          setListFabricantes(result);
          setSateLoading(false);
      }});
  };

  useEffect(() => {
    searchFabricantes(fabricanteFilterChecked);
  }, []);

  return (
    <Grid container={true} direction="column" spacing={16}>
      <Grid item={true} xs={12}>
        <Card>
          <CardContent>
            <Snackbar
              anchorOrigin={{
                horizontal: "center",
                vertical: "center",
              }}
              open={alert.open}
              autoHideDuration={4000}
              onClose={closeAlert}
            >
              <SnackbarContent
                message={alert.message}
                style={styles[alert.type]}
              />
            </Snackbar>
            {loading && (
              <LinearProgress />
            )}
            <form>
              <FormGroup row={true}>
                <Grid container={true} spacing={8} alignItems="flex-end">
                  <Grid item={true} xs={4} style={{marginBottom: '48px'}}>
                    <SelectSingle 
                      value={editora} 
                      onChange={handleEditora}  
                      options={listEditoras}
                      placeholder={"Editoras SimpleSet"} />
                  </Grid>
                  <Grid item={true} xs={8}>
                    <FormControlLabel 
                      style={{marginTop: '0px'}}
                      control={
                        <Switch
                        checked={editoraFilterChecked}
                        value=""
                        onClick={handleEditorasChecked}
                        color="primary"    
                        />
                      }
                        label="Apenas Editoras Simpleset Não Associadas"
                    />
                  </Grid>
                </Grid>
                <Grid container={true} spacing={8} style={{marginTop: '30px'}}>
                  <Grid item={true} xs={4}>
                  <SelectSingle 
                    value={fabricante} 
                    onChange={handleFabricante}  
                    options={listFabricantes}
                    placeholder={"Editoras Bookinfo"} />
                  </Grid>
                  <Grid item={true} xs={8}>
                    <FormControlLabel style={{marginTop: '0px'}}
                      control={
                        <Switch
                        checked={fabricanteFilterChecked}
                        value=""
                        onClick={handleFabricanteChecked}
                        color="primary"    
                        />
                      }
                        label="Apenas Editoras Bookinfo Não Associadas"
                    />
                  </Grid>
                </Grid>
              </FormGroup>
            </form>
          </CardContent>
          <CardActions>
            <Button
              onClick={closeForm}
              className="filter-dialog-close"
              color="secondary"
            >
              Cancelar
            </Button>
            <Button
              onClick={saveEditora}
              className="filter-dialog-close"
              color="primary"
            >
              Salvar
            </Button>
          </CardActions>
        </Card>
      </Grid>
    </Grid>
  );
}

export default EditoraFabricanteForm;



// WEBPACK FOOTER //
// ./src/component/administration/editoraFabricante/EditoraFabricanteForm.tsx